import * as getters from './Getters'
import * as actions from './Actions'
import * as mutations from './Mutaions'

//Statelerimiz
const state = () => ({
    loading: false,
    login : {},
    userStatus : {},
    users: [],
    menus: [],
    auth: [],
    types: [],
    userPageInfo:{},
    logs:[],
    logsPageInfo:{},
    user: {},
    authCasbin: [],
    authsCasbin: [],
    authMenus:[],
    widgets: [],
    widgetVal: [],
})

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/Users/index.js